//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'defaultTip',
  data() {
    return {
      mapWord: {
        content: '暂无内容，去别处逛逛吧〜',
        dynamic: '还没有动态，快去发布吧〜',
        error: '出错啦，快看页面飞走啦〜',
        friend: '还没有好友，赶紧去添加吧〜',
        network: '网络出问题了，快去检查一下吧〜',
        search: '无搜索结果，换个词试试吧〜',
        star: '还没有关注，赶快人去关注一波吧〜'
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'content'
    }
  },
  components: {

  },
  mounted: function() {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/defaultTip/index.vue